import { IDisciplinasObrigatoriasComponentProps } from '@/@types/Graduacao/DisciplinasObrigatorias';

// components
import { ItemSemestreDisciplinasObrigatorias } from './ItemSemestreDisciplinasObrigatorias';
import { CardHeader } from '@/components/shared/CardHeader';
import { InputWithLabel } from '@/components/shared/InputWithLabel';
import { Loading } from '@/components/shared/Loading';
import { AlertMessage } from '@/components/shared/AlertMessage';



/**
 * Componente para exibir as disciplinas obrigatórias
 * @param isLoading Indica se os dados estão sendo carregados
 * @param data Dados das disciplinas obrigatórias
 * @param ano Ano do catálogo das disciplinas
 * @param setAno Função para atualizar o ano do catálogo das disciplinas
 * @returns Componente para exibir as disciplinas obrigatórias
 */

const DisciplinasObrigatoriasComponent= ({ isLoading, data, ano, setAno }: IDisciplinasObrigatoriasComponentProps) => {

    const renderSemesterItem = (semester: number) => {
        // renderiza um item de semeste com base no número do semestre (1 - 10) e nos dados das disciplinas
        return (
            <ItemSemestreDisciplinasObrigatorias key={semester} semestre={semester} data={data} />
        );
    };

    const renderAllSemesters = () => {
        // renderiza todos os semestres, chamando renderSemesterItem para cada um
        const semesters = [];
        for (let i = 1; i <= 10; i++) {
            semesters.push(renderSemesterItem(i));
        }
        return semesters;
    };


    return (
        <div>

            <div className='mt-[16px] font-normal text-[#252525] flex-col space-y-[12px]'>

                <p>Matriz Curricular do Curso de Graduação em Engenharia Agrícola </p>

                <p>Programas e Bibliografias das Disciplinas</p>
            </div>

            <div className='mt-[16px] border-[1px] rounded-[0.25rem] bg-white break-words'>

                <CardHeader>
                    <InputWithLabel
                        type='number'
                        placeholder='Digite o Ano Catálogo'
                        label='Ano Catálogo'
                        min={2014}
                        value={ano}
                        onChange={({target}) => setAno(parseInt(target.value))}
                    />
                </CardHeader>

                <div className='pt-[0.75rem] pb-[0.75rem] pr-[1.25rem] pl-[1.25rem] font-normal'>


                    {isLoading ? <Loading color='primary' /> : (

                        <>
                            {data.length == 0 ? <AlertMessage message={`Não foi encontrada nenhuma matriz curricular.`} /> : (

                                <>
                                    <h3>Matriz Curricular do Curso de Graduação</h3>

                                    <h5>( ) Número de créditos das disciplinas</h5>

                                    <div>

                                        {renderAllSemesters()}

                                        <h6 className='mt-[24px]'>Obs: Cada sigla de disciplina é clicável e leva a mais informações no Site da DAC</h6>
                                    </div>
                                </>

                            )}
                        </>
                    )}

                </div>

            </div>


        </div>

    );
}

export { DisciplinasObrigatoriasComponent };